import {
    GET_FAVORITES,
    GET_FAVORITES_RESET,
    POST_FAVORITE,
    POST_FAVORITE_RESET,
    POST_UNFAVORITE,
    POST_UNFAVORITE_RESET, SUBMIT_CREDIT_REQUEST_FORM, SUBMIT_CREDIT_REQUEST_FORM_RESET,
    UPDATE_FAVORITES
} from '../actions/account';

const initialState = {
    favorites: [],
    favorite: {},
    unfavorite: {},
    postFavoriteMerchantId: null,
    getFavoritesSuccess: null,
    getFavoritesError: null,
    postFavoriteSuccess: null,
    postFavoriteError: null,
    postUnfavoriteSuccess: null,
    postUnfavoriteError: null,
    submitCreditRequestFormSuccess: null,
    submitCreditRequestFormError: null
};

export default function accountReducer(state = initialState, action) {
    switch (action.type) {
        case SUBMIT_CREDIT_REQUEST_FORM:
            return {
                ...state,
                ...(action.payload && action.payload.submitCreditRequestFormSuccess && {
                    submitCreditRequestFormSuccess: true,
                    submitCreditRequestFormRefundedAmount: action.payload.refundedAmount
                }),
                submitCreditRequestFormError: action.error
            };
        case SUBMIT_CREDIT_REQUEST_FORM_RESET:
            return {
                ...state,
                submitCreditRequestFormSuccess: initialState.submitCreditRequestFormSuccess,
                submitCreditRequestFormError: initialState.submitCreditRequestFormError
            };
        case GET_FAVORITES:
            return {
                ...state,
                ...(action.payload && action.payload.favorites && {
                    getFavoritesSuccess: true,
                    favorites: action.payload.favorites
                }),
                getFavoritesError: action.error
            };
        case GET_FAVORITES_RESET:
            return {
                ...state,
                getFavoritesSuccess: initialState.getFavoritesSuccess,
                getFavoritesError: initialState.getFavoritesError
            };
        case UPDATE_FAVORITES:
            return {
                ...state,
                favorites: action.payload.favorites
            };
        case POST_FAVORITE:
            return {
                ...state,
                ...(action.payload && action.payload.favorites && {
                    favorites: action.payload.favorites,
                    postFavoriteSuccess: true
                }),
                postFavoriteError: action.error
            };
        case POST_FAVORITE_RESET:
            return {
                ...state,
                postFavoriteSuccess: initialState.postFavoriteSuccess,
                postFavoriteError: initialState.postFavoriteError,
            };
        case POST_UNFAVORITE:
            return {
                ...state,
                ...(action.payload && action.payload.favorites && {
                    favorites: action.payload.favorites,
                    postUnfavoriteSuccess: true
                }),
                postUnfavoriteError: action.error
            };
        case POST_UNFAVORITE_RESET:
            return {
                ...state,
                postUnfavoriteSuccess: initialState.postUnfavoriteSuccess,
                postUnfavoriteError: initialState.postUnfavoriteError,
            };
        default:
            return state;
    }
}